import React from "react";
import { BusinessOutlined } from "@mui/icons-material";
import {
  Badge,
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import EmptyResult from "components/Shared/Lottie/EmptyResult";

const BranchAssignmentBranchTab = ({ branchDetail }) => {
  const branches =
    branchDetail && Array.isArray(branchDetail) ? branchDetail : [];

  return (
    <Grid item xs={12}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        p={3}
      >
        <Box display="inline-flex" alignItems="center" gap={1.5}>
          <Badge badgeContent={branches.length} color="primary">
            <BusinessOutlined style={{ color: "gray" }} />
          </Badge>

          <Typography style={{ fontWeight: 500 }}>Branches</Typography>
        </Box>
      </Box>

      <Divider />
      <Box p={2}>
        {branches.length > 0 ? (
          <BranchCard branches={branches} />
        ) : (
          <EmptyResult height={150} />
        )}
      </Box>
    </Grid>
  );
};

export default BranchAssignmentBranchTab;

const BranchCard = ({ branches = [] }) => {
  const validBranches = branches.filter(
    (branch) => branch?.id && branch?.label
  );

  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
      {validBranches?.length > 0 ? (
        validBranches.map((branch) => (
          <div key={branch?.id} className="group">
            <Card
              className="h-full transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl"
              sx={{
                borderRadius: 2,
                "&:hover": {
                  boxShadow:
                    "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                },
              }}
            >
              <CardContent sx={{ padding: 2 }}>
                <div className="flex items-center gap-3">
                  <div className="rounded-full bg-green-100 p-2 transition-colors group-hover:bg-green-200">
                    <BusinessOutlined
                      sx={{
                        fontSize: 20,
                        color: "primary.main",
                      }}
                    />
                  </div>
                  <Typography
                    variant="body2"
                    className="line-clamp-2 font-medium"
                  >
                    {branch.label}
                  </Typography>
                </div>
              </CardContent>
            </Card>
          </div>
        ))
      ) : (
        <EmptyResult height={150} />
      )}
    </div>
  );
};
